import { combineReducers } from 'redux';

import authReducer from './authReducer';
import reportReducer from './reportReducer'
import registerReducer from './registerReducer'
import ActiveIndicatorsReducer from './ActiveIndicatorsReducer';
import FilterReducer from "./FilterReducer";
import DataReducer from "./DataReducer";
import BasicReducer from "./BasicReducer";
import companyReducer from './companyReducer';
import filterOPKReducer from './filterOPKReducer';
import pulpitReducer from './pulpitReducer';
import procedureDefReducer from './procedureDefReducer';
import ProcedurePricingReducer from './ProcedurePricingReducer';
import uploadFileReducer from './uploadFileReducer';
import checkerCreatorReducer from './checkerCreatorReducer'
import GetOpkReducer from './GetOpkReducer'
import GetFourReducer from './GetFourReducer'
import UserReducer from './UserReducer';

export default combineReducers({
    authReducer,
    reportReducer,
    registerReducer,
    Indicators: ActiveIndicatorsReducer,
    Filters: FilterReducer,
    PlotData: DataReducer,
    Basic: BasicReducer,
    ProcedurePricingReducer,
    companyReducer,
    filterOPKReducer,
    pulpitReducer,
    procedureDefReducer, 
    UploadFile: uploadFileReducer, 
    CheckerCreator: checkerCreatorReducer,
    GetOpk: GetOpkReducer,
    GetFours: GetFourReducer,
    UserReducer,

});
